import { useMemo } from "react"
import {
    APIAppTemplateModel,
    nameToSlug,
    TemplateName,
    TemplateSlug
} from "../Models/API/AppTemplateModel"
import { FetchState, hasValue } from "../Models/Client/FetchState"
import { Result } from "../Models/Utility/Result"
import { useAppTemplateList } from "./useAppTemplateList"

/**
 * Returns template for given name or slug, if the template list endpoint's response contains it.
 * Otherwise it returns `Result.error` .
 *
 * Note that you cannot get template for apps created by DataProgramBuilder.
 * For that purpose, use `useAppTemplate` instead.
 */
export function useTemplateFromList(
    templateName?: TemplateName | null,
    templateSlug?: TemplateSlug,
    errorMessage = "Template name was not found"
): FetchState<APIAppTemplateModel> {
    const templateListState = useAppTemplateList()

    return useMemo(() => {
        if (!hasValue(templateListState)) {
            return templateListState
        }
        if (templateName !== undefined && templateName !== null) {
            const template = templateListState.value.items.find(
                item => item.name === templateName
            )

            if (template !== undefined) {
                return Result.ok(template)
            }
        }

        if (templateSlug !== undefined) {
            const template = templateListState.value.items.find(
                item => nameToSlug(item.name) === templateSlug
            )

            if (template) {
                return Result.ok(template)
            }
        }

        return Result.error(errorMessage)
    }, [errorMessage, templateListState, templateName, templateSlug])
}
